import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["canvas"];
  static values = {
    type: {
      type: String,
      default: "line",
    },
    data: Object,
    options: Object,
  };

  connect() {
    Chart.register(ChartDataLabels);
    console.log("connected");
    const element = this.hasCanvasTarget ? this.canvasTarget : this.element;
    this.chart = new Chart(element.getContext("2d"), {
      type: this.typeValue,
      data: this.chartData,
      options: this.chartOptions,
    });
    this.updateChart();
  }

  disconnect() {
    this.chart.destroy();
    this.chart = null;
  }

  updateChart() {
    if (this.chart) {
      this.chart.update();
    }
  }

  get chartData() {
    console.log(this.dataValue);
    if (!this.hasDataValue) {
      console.warn(
        "[stimulus-chartjs] You need to pass data as JSON to see the chart."
      );
    }

    return this.dataValue;
  }

  get chartOptions() {
    return {
      ...this.defaultOptions,
      ...this.optionsValue,
      elements: {
        line: {
          tension: 0.4,
        },
      },
      plugins: {
        datalabels: {
          display: false,
        },
        legend: {
          display: false,
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
          },
          title: {
            display: false
          },
        },
        y: {
          grid: {
            display: true
          },
          title: {
            display: false
          },
        },
      },
    };
  }

  get defaultOptions() {
    return {
      responsive: true,
    };
  }
}
